export default __webpack_public_path__ + "static/media/1.9cd0692b.mp4";